import { render, staticRenderFns } from "./IngredientsView.vue?vue&type=template&id=0d90a5d2&scoped=true"
import script from "./IngredientsView.vue?vue&type=script&lang=js"
export * from "./IngredientsView.vue?vue&type=script&lang=js"
import style0 from "./IngredientsView.vue?vue&type=style&index=0&id=0d90a5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d90a5d2",
  null
  
)

export default component.exports